import React from "react";
import AuthShowcase from "./AuthShowcase";
import "../../style/auth.css";

/**
 * Marco de las pantallas de acceso (entrar, recuperar y restablecer contraseña).
 *
 * Dos columnas: a la izquierda el panel de marca con la ilustración y los
 * mensajes; a la derecha el formulario. En pantallas chicas el panel se reduce
 * a una banda con el logo y el formulario se queda con todo el espacio.
 */
export default function AuthLayout({ title, subtitle, footer, children }) {
  return (
    <div className="auth-page">
      <AuthShowcase />

      <main className="auth-panel">
        <div className="auth-panel-inner">
          {/* El lockup completo, con el subrayado rojo de "Siempre es posible".
              El logo-mini.svg del sidebar es blanco y aquí no se vería. */}
          <img
            className="auth-logo"
            src={`${process.env.PUBLIC_URL}/logo-login.png`}
            alt="LCI — Siempre es posible"
            width="451"
            height="98"
          />

          <header className="auth-heading">
            <h1 className="auth-title">{title}</h1>
            {subtitle && <p className="auth-subtitle">{subtitle}</p>}
          </header>

          {children}

          {footer && <div className="auth-footer">{footer}</div>}
        </div>
      </main>
    </div>
  );
}
